// The numbering rule for duplicates (slice 08; design/16-turn-tracker.md §7,
// design/12 Q3): ONE rule, shared by duplicating a token on the board and
// duplicating a combatant in the tracker, so the two can never drift. Six
// goblins become "Goblin 1" to "Goblin 6".
const NUMBERED = /^(.*\S)\s+(\d+)$/;
/** "Goblin 3" is the stem "Goblin" numbered 3; "Goblin" is unnumbered. */
export function splitNumbered(name) {
    const m = NUMBERED.exec(name.trim());
    return m ? { stem: m[1], n: Number(m[2]) } : { stem: name.trim(), n: null };
}
/**
 * Names for `count` copies of `source`, given every name already at the table.
 * An unnumbered source takes the next free number itself, so the set reads
 * "Goblin 1, Goblin 2, …" rather than "Goblin, Goblin 2, …"; a numbered
 * source keeps its number and the copies continue after the highest taken.
 */
export function numberedNames(source, existing, count) {
    const { stem, n } = splitNumbered(source);
    let next = 0;
    for (const name of existing) {
        const s = splitNumbered(name);
        if (s.stem === stem && s.n !== null && s.n > next)
            next = s.n;
    }
    if (n !== null && n > next)
        next = n;
    next += 1;
    let renamed = source.trim();
    if (n === null) {
        renamed = `${stem} ${next}`;
        next += 1;
    }
    const copies = [];
    for (let k = 0; k < count; k += 1) {
        copies.push(`${stem} ${next}`);
        next += 1;
    }
    return { source: renamed, copies };
}
/**
 * The name a token placed from the compendium takes (qa-runs#362): numbered from the moment it stands on the board,
 * even when it is the only one ("Goblin 1"), continuing after the highest number its stem already has at the table —
 * Duplicate's own rule. A name the DM typed with a number of its own keeps that number.
 */
export function placedName(name, existing) {
    return numberedNames(name, existing, 0).source;
}
/**
 * The other members of a numbered group (design/22 Q2): every name sharing
 * `name`'s stem with a number of its own. Revealing part of such a group
 * tells the players the rest may exist — "Goblin 4" alone implies 1 to 3 —
 * so the DM is reminded, never stopped.
 */
export function numberedMates(name, names) {
    const { stem, n } = splitNumbered(name);
    if (n === null)
        return [];
    return names.filter((other) => other !== name && (() => { const s = splitNumbered(other); return s.stem === stem && s.n !== null; })());
}
//# sourceMappingURL=naming.js.map